import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  systemList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/orphan/system')
        .then(({ data }) => {
          context.commit('SYSTEM_LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  clientList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/orphan/client')
        .then(({ data }) => {
          context.commit('CLIENT_LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  systemDestroyed (context, opts) {
    // always try to remove from list
    context.commit('SYSTEM_LIST_REMOVE', opts)
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  clientDestroyed (context, opts) {
    // always try to remove from list
    context.commit('CLIENT_LIST_REMOVE', opts)
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  // // ===========================List Edits===============================
  systemDelete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/orphan/system/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  clientDelete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/orphan/client/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  systemDetail (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/orphan/system/${opts}`)
        .then(({ data }) => {
          context.commit('CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
